import { render, staticRenderFns } from "./add_xingtu.vue?vue&type=template&id=04ecf540&scoped=true&"
import script from "./add_xingtu.vue?vue&type=script&lang=js&"
export * from "./add_xingtu.vue?vue&type=script&lang=js&"
import style0 from "./add_xingtu.vue?vue&type=style&index=0&id=04ecf540&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ecf540",
  null
  
)

export default component.exports